// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6527":"ef17f6ee","8844":"7ea8685d"}[chunkId] + ".chunk.css";
};